export default class GoogleMapsPlacesService {
  constructor({
    placesService,
    autocompleteService,
    autocompleteSessionToken,
    geocoderService,
  }) {
    this.placesService = placesService;
    this.autocompleteService = autocompleteService;
    this.autocompleteSessionToken = autocompleteSessionToken;
    this.geocoderService = geocoderService;
  }

  getDetails = (request) =>
    new Promise((resolve) => this.placesService.getDetails(request, resolve));

  getPredictions = (request) =>
    new Promise((resolve) =>
      this.autocompleteService.getPlacePredictions(
        {
          ...request,
          sessionToken: this.autocompleteSessionToken,
        },
        (predictions) => resolve(predictions || [])
      )
    );

  getUsersCountryCode = (latitude, longitude) => {
    return new Promise(
      (resolve, reject) => {
        const { LatLng } = google.maps;
        const location = new LatLng(latitude, longitude);

        this.geocoderService.geocode(
          { location: location },
          (results, status) => {
            if (status !== 'OK') {
              reject(new Error('Geocoder failed due to: ' + status));
              return;
            }
            if (!results[0]) {
              reject(new Error('No results found'));
              return;
            }

            const countryComponent = results[0].address_components.find(
              (component) => component.types.includes('country')
            );
            const countryCode = countryComponent
              ? countryComponent.short_name
              : null;
            resolve(countryCode);
          }
        );
      },
      (error) => {
        reject(error);
      }
    );
  };
}

export function createGoogleMapsPlacesService({
  places: { PlacesService, AutocompleteService, AutocompleteSessionToken },
  Geocoder,
}) {
  const attrContainer = document.createElement('div');
  attrContainer.style.display = 'none';
  document.body.appendChild(attrContainer);
  return new GoogleMapsPlacesService({
    placesService: new PlacesService(attrContainer),
    autocompleteService: new AutocompleteService(),
    autocompleteSessionToken: new AutocompleteSessionToken(),
    geocoderService: new Geocoder(),
  });
}
